/**
 * Better Auth's browser client.
 *
 * Same origin, so there is no baseURL to configure: the API lives under
 * /api/auth on the page's own host, which is also what keeps the session
 * cookie host-only.
 *
 * Every request carries the interface language in `X-App-Locale`. It is set
 * here rather than at the call sites because four of them can cause a message
 * to be sent — register, sign in, resend verification, request a reset, and
 * the reset itself — and a header that has to be remembered five times is a
 * header that will be forgotten once. Better Auth lifts a client-level
 * `onRequest` into a fetch plugin, so a per-call `fetchOptions` adds to this
 * rather than replacing it.
 *
 * If it ever does go missing the Worker writes Bulgarian, which is the right
 * answer for this site — see `mailLocale` in `src/shared/locale.ts`.
 */

import { createAuthClient } from 'better-auth/react'
import { LOCALE_HEADER } from '../../shared/locale.ts'
import { currentLocale } from '../i18n/current-locale.ts'

export const authClient = createAuthClient({
  basePath: '/api/auth',
  fetchOptions: {
    onRequest: (context) => {
      context.headers.set(LOCALE_HEADER, currentLocale())
    },
  },
})
